import { ReduxHelper } from "helpers";
import { ICurrentUserResponse } from "models/ResponseModels";

export const prefix = "USER";

const getCurrentUserInfo = ReduxHelper.generateActions<void, ICurrentUserResponse>(`${prefix}/GET_USER_INFO`);

export { getCurrentUserInfo };
